import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["results", "hidden", "showStatus"]
  static values = {
    title: { type: String, default: null },
    statuses: { type: Array },
    nameform: { type: String, default: "application_status" },
    selected: { type: String, default: null },
    attributes: { type: String, default: null },
    negativeStatuses: { type: Array, default: [] },
  }

  connect() {
    this.stylesheet();
    this.hiddenResult();
    this.renderOptionsHtmlDefault();
  }

  renderOptionsHtmlDefault() {
    if (!this.hasHiddenTarget && this.hasResultsTarget && this.resultsTarget) {
      this.renderOptionsHtml();
    }
  }

  renderOptionsHtml() {
    this.resultsTarget.innerHTML = this.applicationStatusHtml();
  }

  hiddenResult() {
    if (this.hasHiddenTarget) {
      this.hiddenTargets.forEach(item => item.classList.add('d-none'))
      this.hiddenAllCurrentStatus();
    }
  }

  displayResult() {
    if (this.hasHiddenTarget) {
      this.hiddenTargets.forEach(item => item.classList.remove('d-none'));
      this.hiddenAllCurrentStatus();
      this.showCurrentStatus();
    }
  }

  hiddenAllCurrentStatus() {
    if (!this.hasShowStatusTarget) return;
    this.showStatusTarget.querySelectorAll('span').forEach(span => span.classList.add('d-none'));
  }

  showCurrentStatus() {
    if (!this.hasShowStatusTarget) return;
    this.showStatusTarget.querySelector(`[data-scout-id="${event.currentTarget.dataset.scoutid}"]`).classList.remove('d-none');
  }

  handleClick(event) {
    const isOpen = event.currentTarget.dataset.openapplicationstatus;
    if (isOpen == 1) {
      this.renderOptionsHtml();
      this.displayResult();
    } else {
      this.resultsTarget.innerHTML = "";
      this.hiddenResult();
    }
  }

  applicationStatusHtml() {
    let html = '<div class="application-status-group">';
    let positiveGroupHtml = '<div class="application-status-group-positive d-flex flex-wrap">';
    let negativeGroupHtml = '<div class="application-status-group-negative d-flex flex-wrap">';
    for (let i = 0; i < this.statusesValue.length; i++) {
      if (this.hasNegativeStatusesValue && this.negativeStatusesValue.includes(this.statusesValue[i][1])) {
        negativeGroupHtml += this.groupStatusHtml(this.statusesValue[i]);
      } else {
        positiveGroupHtml += this.groupStatusHtml(this.statusesValue[i]);
      }
    }
    html += positiveGroupHtml + '</div>';
    html += negativeGroupHtml + '</div>';
    html+= '</div">';
    return html;
  }

  groupStatusHtml(status) {
    let isChecked = this.hasSelectedValue ? this.selectedValue == status[1] : false;
    let attrs = this.hasAttributesValue ? this.attributesValue : null;
    let groupHtml = '<div class="form-check custom-form-check p-0">';
    groupHtml+= `<input class="form-check-input d-none" ${attrs} type="radio" value="${status[1]}" name="${this.nameformValue}" id="application_status_${status[1]}" ${isChecked ? 'checked' : ''}></input>`;
    groupHtml+= `<label for="application_status_${status[1]}" class="form-check-label btn btn-sm btn-outline-primary rounded-pill">${status[0]}</label>`;
    groupHtml+= '</div>';
    return groupHtml;
  }

  stylesheet() {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(`
      .application-status-group {
        display: flex;
        flex-direction: column;
        gap: 1rem;

        .application-status-group-positive {
          gap: 1rem;

          .form-check.custom-form-check {
            .form-check-label {
              font-size: .85rem !important;
            }

            .form-check-input:checked~.form-check-label {
              background-color: #0b97e6;
              color: #fff;
            }
          }
        }

        .application-status-group-negative {
          gap: 1rem;

          .form-check.custom-form-check {
            .form-check-label {
              color: #966DFE;
              border-color: #966DFE;
              font-size: .85rem !important;
              &:hover {
                background-color: #966DFE;
                color: #fff;
              }
            }

            .form-check-input:checked~.form-check-label {
              background-color: #966DFE;
              color: #fff;
            }
          }
        }
      }
    `);
    document.adoptedStyleSheets = [...document.adoptedStyleSheets, sheet];
  }
}
